export default "__VITE_ASSET__DEaZUiDD__"